import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  dangerousGoods: {
    id: 'rjgYC9',
    defaultMessage: 'Dangerous Goods',
    description: 'Dangerous Goods',
  },
  unNumber: {
    id: 'ctuN/o',
    defaultMessage: 'UN Number',
    description: 'Input label for UN Number for dangerous goods form',
  },
  shippingName: {
    id: 'fEP3za',
    defaultMessage: 'Shipping Name',
    description: 'Input label for Shipping Name for dangerous goods form',
  },
  technicalName: {
    id: '/dxIH9',
    defaultMessage: 'Technical Name',
    description: 'Input label for Technical Name for dangerous goods form',
  },
  productClass: {
    id: '0aMfss',
    defaultMessage: 'Class',
    description: 'Input label for Product Class for dangerous goods form',
  },
  subsidiaryRisk: {
    id: 'i0ALgB',
    defaultMessage: 'Subsidiary Risk',
    description: 'Input label for Subsidiary Risk for dangerous goods form',
  },
  selectAnOption: {
    id: 'NBsT8S',
    defaultMessage: 'Select an option',
    description: 'Placeholder for select input',
  },
  packagingGroup: {
    id: '6P8hTT',
    defaultMessage: 'Packaging Group',
    description: 'Input label for Packaging Group for dangerous goods form',
  },
  amount: {
    id: 'uahbEa',
    defaultMessage: 'Amount',
    description: 'Input label for Amount for dangerous goods form',
  },
  unit: {
    id: 'KkKuy/',
    defaultMessage: 'Unit',
    description: 'Input label for Unit for dangerous goods form',
  },
  packagingType: {
    id: 'CIhbNx',
    defaultMessage: 'Packaging Type',
    description: 'Input label for Packaging Type for dangerous goods form',
  },
  quantity: {
    id: 'kGfea0',
    defaultMessage: 'Quantity',
    description: 'Input label for Quantity for dangerous goods form',
  },
  productHazardClass: {
    id: '6lW8Gg',
    defaultMessage: 'Product Hazard Class',
    description: 'Input label for Product Hazard Class for dangerous goods',
  },
  subHazard: {
    id: 'H8tF74',
    defaultMessage: 'Sub Hazard',
    description: 'Input label for Sub Hazard for dangerous goods',
  },
});
